$("#pdfmonkey_product_submit").on('click', function(e){
	e.preventDefault();
      $('#pdfmonkey_product_submit .loader').removeClass('hide');
      $('#pdfmonkey_product_submit').addClass('loader-active');
  	e.target.value = "✔︎ " + e.target.value;
  	e.target.disabled = true;
  	var url = location.href;
  	url = url.split('?');
    url = url[0];
  setTimeout(function(){
    var metafield = {};
      $('#selected_variant_metafield_values input').each(function(){
    	var key = $(this).attr('class');
        key= key.substring(10,key.length);
        var value = $(this).val();
        metafield[key] = value;
      });
    var product_data =
    {
      product:{
        title: $('.product-detail-block .product-single__title').text(),
        sku: $('#variant_sku').text(),
        main_image: $('.product_main_image').val(),
        option1_name: $('.selector-wrapper.option-1 label').text(),
        option1_value: $('.selector-wrapper.option-1 select option:selected').text(),
        option2_name: $('.selector-wrapper.option-2 label').text(),
        option2_value: $('.selector-wrapper.option-2 select option:selected').text(),
        option3_name: $('.selector-wrapper.option-3 label').text(),
        option3_value: $('.selector-wrapper.option-3 select option:selected').text(),
        metafield
      }
    };
  	var sku = $('#variant_sku').text();
    productData = JSON.stringify(product_data);
    console.log(productData);
    
      $.ajax({
        async: true,
        crossDomain: true,
        url: "https://api.pdfmonkey.io/api/v1/documents",
        method: "POST",
        headers: {
          "authorization": "Bearer EPzxUE7Do8WrMxvJeFS5",
          "content-type": "application/json",
        },
        processData: false,
        dataType: "json",
        data: "{\r\n        \"document\": {\r\n          \"document_template_id\": \"2CE64FB2-C30C-48C6-B9F7-9D835F15AB6F\",\r\n      \"meta\": {\r\n    \"_filename\": \"Motionspot - "+sku+".pdf\"   \r\n        }\r\n,      \"payload\": "+productData+",\r\n          \"status\": \"pending\"\r\n          \r\n        }\r\n      }",
        beforeSend: function(xhr){
          xhr.setRequestHeader('Access-Control-Allow-origin', 'true');
        },

        success: function(data) {
          console.log(data);
          var id ='';
          id = data.document.id;
          var settings1 = {
            "async": true,
            "crossDomain": true,
            "url": "https://api.pdfmonkey.io/api/v1/documents/"+id,
            "method": "GET",
            "headers": {
              "authorization": "Bearer EPzxUE7Do8WrMxvJeFS5"
            }
          }
          setTimeout(function(){
          $.ajax(settings1).done(function (response1) {
            var download_url = response1.document.download_url;
            console.log(response1);
            console.log(download_url);
                $('#pdfmonkey_product_submit .loader').addClass('hide');
                $('#pdfmonkey_product_submit').removeClass('loader-active');
                location.href = download_url;
            	
          });
             }, 3000);
        },
        error: function(jqXHR, msg, erro){
          console.log(jqXHR);
          console.log(msg);
          console.log(erro);
        }
      });
       }, 3000);
});

// document.addEventListener("click", function (event) {
//   if (!event.target.matches("#pdfmonkey_cart_submit") || (event.target.disabled)) return;
//   setTimeout( function () { 
// 	event.preventDefault();
//   	event.target.value = "✔︎ " + event.target.value;
//   	event.target.disabled = true;
//   	jQuery.getJSON('/cart.js', function(cart) {
// 	var cartData = JSON.stringify(cart);
//     console.log(cartData);
    
//       $.ajax({
//         async: true,
//         crossDomain: true,
//         url: "https://api.pdfmonkey.io/api/v1/documents",
//         method: "POST",
//         headers: {
//           "authorization": "Bearer EPzxUE7Do8WrMxvJeFS5",
//           "content-type": "application/json",
//         },
//         processData: false,
//         dataType: "json",
//         data: "{\r\n        \"document\": {\r\n          \"document_template_id\": \"B3B98A0E-10F7-4788-9978-5E4190111278\",\r\n     \"meta\": {\r\n    \"_filename\": \"Motionspot - Your product specification.pdf\"   \r\n        }\r\n,     \"payload\": "+cartData+",\r\n          \"status\": \"pending\"\r\n          \r\n        }\r\n      }",
//         beforeSend: function(xhr){
//           xhr.setRequestHeader('Access-Control-Allow-origin', 'true');
//         },

//         success: function(data) {
//           console.log(data);
//           var app_id ='';
//           app_id = data.document.id;
//           var settings1 = {
//             "async": true,
//             "crossDomain": true,
//             "url": "https://api.pdfmonkey.io/api/v1/documents/"+app_id,
//             "method": "GET",
//             "headers": {
//               "authorization": "Bearer EPzxUE7Do8WrMxvJeFS5"
//             }
//           }
//           setTimeout(function(){
//           $.ajax(settings1).done(function (response1) {
//             var download_url = response1.document.download_url;
//             console.log(response1);
//             console.log(download_url);
//           });
//              }, 3000);
//         },
//         error: function(jqXHR, msg, erro){
//           console.log(jqXHR);
//           console.log(msg);
//           console.log(erro);
//         }
//       });
//   	});
  
  
// //         $('#pdfmonkey_cart_submit').submit();
//     }, 3000);
// }, false);


